/** @license ISC License (c) copyright 2019 original and current authors */
/** @author Dale Francis (dalefrancis88) */

// isFalse : a -> Boolean
function isFalse(x) {
  return x === false
}

module.exports = isFalse
